
import Button from '~/components/detail/Button.vue'
export default {
  components: { Button },
  props: {
    wikinum: {
      // 天眼号
      type: String,
      default: ''
    },
    addtradertype: {
      // 1加入还是2认领3认证
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      radio: 0,
      textarea: ''
    }
  },
  watch: {
    textarea(newval) {
      const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
      if (regex.test(newval)) {
        this.$emit('setwebsitepost', newval)
      } else {
        this.$emit('setwebsitepost', '')
      }
    }
  },
  methods: {
    fuzhi() {
      // 复制文本
      const val = this.$v('我已成功入驻WikiFX (天眼ID：{0})，为提升公司品牌知名度跨出了重要的一步。').replace('{0}', this.wikinum)
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', val)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$v('复制成功'),
        type: 'warning'
      })
      document.body.removeChild(input)
    }
  }
}
